import { CommonService } from 'src/app/shared/services/common.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GrievanceService } from 'src/app/shared/services/grievance.service';
import { MediaFileService } from 'src/app/shared/services/media-file.service';
import { IKeyValuePair } from 'src/app/_models/common/common';
import { IPaged } from 'src/app/_models/common/IPaged';
import { IGrievance } from 'src/app/_models/grievance/IGrievance';

@Component({
  selector: 'app-add-givance',
  templateUrl: './add-givance.component.html',
  styleUrls: ['./add-givance.component.css']
})
export class AddGivanceComponent implements OnInit {

  @Output() closeForm: EventEmitter<any> = new EventEmitter();
  title: string = 'Add Return - 85';
  private readonly PAGE_SIZE = 10;
  loading: boolean;
  userMasterForm: FormGroup;
  userGrievance: IGrievance;
  fileToUpload: File = null;
  Id;
  url;
  docId;
  reason3;
  serviceRequestDetails: any;
  barWidth: number = 0;
  isProgress: boolean = false;
  isTermsandCondi: boolean = false;
  retpostatuss;

  returTypes: any[];
  grievanceFrom: FormGroup;
  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Desc',
    retururl: 0,
    id: 0,
    title: '',
  };

  constructor(
    private router: Router,
    private grievanceService: GrievanceService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private mediaFileService: MediaFileService,
    private modalService: NgbModal,
    private toastrService: ToastrService,
    private authService: AuthService,
    private fb: FormBuilder) {
    //this.userMasterId = this.authService.currentUserId;
  }

  ngOnInit(): void {
    this.creatGrievanceForm()
    this.bindDropDown()
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort ? params.sort : 'Id';
        this.query.sortDir = params.sortDir ? params.sortDir : this.query.sortDir;
        this.query.id = params.id ? params.id : this.query.id;
        this.query.title = params.title ? params.title : '';
      });
    this.grievanceService.get(this.query.id).subscribe((response: any) => {
      if (response) {
        this.userGrievance = response;
        this.setValueGrievanceForm();
      }
    });
  }

  creatGrievanceForm() {
    this.grievanceFrom = this.fb.group({
      //userMasterId: [this.userMasterId],
      grievanceTypeId: ['', Validators.required],
      comment: ['', Validators.required],
      docId: [this.docId],
    });
  }
  setValueGrievanceForm() {
    this.grievanceFrom.patchValue({
      //userMasterId: this.userGrievance.userMasterId,
      grievanceTypeId: this.userGrievance.grievanceTypeId,
      comment: this.userGrievance.comment,
      docId: this.userGrievance.docId,
    });
  }
  // deleteUserknownLanguage(id) {
  //   if (!confirm('Are you sure you want to delete this data?')) return;
  //   this.serviceRequestService.serviceRequestDocDelete(id).subscribe(() => {
  //     this.toastrService.success('This row deleted successfully.');
  //     this.ngOnInit()
  //   });
  // }
  // loadserviceRequestDoc() {
  //   this.serviceRequestService.getserviceRequestDocList().subscribe((response: any) => {
  //     if (response) {
  //       this.query = response;
  //     }
  //   });
  // }
  bindDropDown() {
    this.commonService.getGrievanceTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.returTypes = response;
      }
    });
  }
  submit() {
    if (this.grievanceFrom.valid) {
      this.loading = true;
      this.userGrievance = Object.assign({}, this.grievanceFrom.value);
      if (this.query.id) {
        this.userGrievance.parentId = this.query.id;
        this.grievanceService.create(this.userGrievance).subscribe((response: any) => {
          if (response) {
            this.toastrService.success('Your Request have been successfully submitted.');
            this.router.navigate(['/employee/grievance']);
          }
          else {
            this.router.navigate(['/employee/grievance']);
          }
        });
      } else {
        this.grievanceService.create(this.userGrievance).subscribe((response: any) => {
          if (response) {
            this.toastrService.success('Your Request have been successfully submitted.');
            this.router.navigate(['/employee/grievance']);
          }
          else {
            this.router.navigate(['/employee/grievance']);
          }
        });
      }
    }
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }
  onDocumentUpload(inputDoc) {
    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          this.grievanceFrom.patchValue({
            docId: event.body.id
          });
        }
      },
      (error) => {
        console.log(error);
        inputDoc.value = null;
      },
      () => console.log("complete"));
  }

  cancelClick() {
    this.router.navigate(['/employee/grievance']);
  }
}
